module.exports = __webpack_public_path__ + "static/img/service_introduce_TH02_zh.aeb8eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_TH02_zh.png
// module id = LSW2
// module chunks = 34